import { graphql } from "../generated";

export const UserAccountsDocument = graphql(`
  query UserAccounts {
    me {
      organizationalUnitAccess {
        hasMultipleRootUnits
        hasMultipleLeafUnits
        defaultRootOrgUnit {
          key
          resourceKey
          name
          resourceType
          resourceAttributes
        }
        defaultLeafOrgUnit {
          key
          resourceKey
          name
          resourceType
          resourceAttributes
        }
      }
    }
  }
`);

export const ClientAccountDocument = graphql(`
  query ClientAccount($key: ID!) {
    clientAccount(key: $key) {
      key
      enablePlatformAI
    }
  }
`);
